import { useEffect, useMemo } from "react";
import { useConfiguration } from "../../contexts/ConfigurationContext";
import { usePresenter } from "../../contexts/PresenterContext";

interface CollectPresentationProps {}
interface CollectPresentationReturn {
    slideSources: any[];
    slideCount: number;
    slideTracks: any[];
}

const useCollectPresentation = ({}: CollectPresentationProps) => {
    const { currentMediaId, mediasData } = useConfiguration();
    const { setPresentationPublishedSlides } = usePresenter();
    const currentMedia = useMemo(() => mediasData.find(({ id, originalId }: any) => id === currentMediaId || originalId === currentMediaId), [currentMediaId, mediasData]);

    const slideSources = useMemo(() => {
        if (!currentMedia || (currentMedia.tracks ?? []).length === 0 || (currentMedia?.images ?? []).length === 0) {
            return [];
        }
        return (currentMedia?.images ?? []).filter((image: any) => image.collectionId?.startsWith("slide-"));
    }, [currentMedia]);

    const slideTracks = useMemo(() => {
        if (!currentMedia || (currentMedia.tracks ?? []).length === 0 || (currentMedia?.images ?? []).length === 0) {
            return [];
        }

        const srcs = currentMedia.images.filter((image: any) => image.collectionId?.startsWith("slide-"));
        let sequences = currentMedia?.tracks?.find((track: any) => track.name === 'pdf-track')?.sequences ?? [];
        sequences = sequences.map((track: any) => {
            const trackSrc = srcs.filter((src: any) => src.collectionId === track?.resource?.id);
            if (trackSrc && track.images?.length === 0) {
                return { ...track, images: trackSrc };
            }

            return track;
        });
        return sequences;
    }, [currentMedia]);

    useEffect(() => {
        setPresentationPublishedSlides(slideTracks);
        // `setPresentationPublishedSlides` isn't memoized in PresenterContext, so it gets a new
        // reference on every PresenterProvider render (including the one this call itself
        // triggers) — including it here would re-fire this effect forever.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [slideTracks]);

    return { slideTracks, slideSources, slideCount: slideTracks.length } as CollectPresentationReturn;
};
export default useCollectPresentation;
